module.exports = __webpack_public_path__ + "img/dp-infinity-symbol.21296bc5.png";